module.exports = __webpack_public_path__ + "static/media/Icono.1b9e8bef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Icono.png
// module id = 143
// module chunks = 0